<template>
    <div id="candidate-logins">
        <section class="section col-md-12">
            <div class="section__header">
                <div class="section__title">
                    {{ getTranslation('loginHistory') }} - <span v-if="paginated">{{ pagination.total || logins.length }}</span><span v-else>{{ logins.length }}</span>
                </div>
            </div>
            <div class="section__body">
                <table class="table-3 table-borderless">
                    <thead class="table-3__head">
                        <tr v-if="paginated" class="table-3__row">
                            <th v-if="!candidateId">
                                <form @submit.prevent="filterForm.page=1;fetchLogins()">
                                    <div class="field-advanced">
                                        <div class="field-advanced__inner">
                                            <div class="field-advanced__field-wrap">
                                                <input v-model="filterForm.query" class="field  field--full-width  field--bg-grey  js-borderOnFocus" type="text" :placeholder="getTranslation('searchByfioPin')">
                                            </div>
                                            <div class="field-advanced__right">
                                                <button class="btn  btn--square  btn--main">
                                                    <svg class="btn__icon">
                                                        <use xlink:href="#icon__search"></use>
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </th>
                            <th v-if="!appId && !eventId">
                                <form @submit.prevent="filterForm.page=1;fetchLogins()">
                                    <div class="field-advanced">
                                        <div class="field-advanced__inner">
                                            <div class="field-advanced__field-wrap">
                                                <input v-model="filterForm.appQuery" class="field  field--full-width  field--bg-grey  js-borderOnFocus" type="text" :placeholder="getTranslation('searchByName')">
                                            </div>
                                            <div class="field-advanced__right">
                                                <button class="btn  btn--square  btn--main">
                                                    <svg class="btn__icon">
                                                        <use xlink:href="#icon__search"></use>
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </th>
                            <th>
                                <form @submit.prevent="filterForm.page=1;fetchLogins()">
                                    <div class="field-advanced">
                                        <div class="field-advanced__inner">
                                            <div class="field-advanced__field-wrap">
                                                <input v-model="filterForm.ipAddress" class="field  field--full-width  field--bg-grey  js-borderOnFocus" type="text" :placeholder="getTranslation('ipAddress')">
                                            </div>
                                            <div class="field-advanced__right">
                                                <button class="btn  btn--square  btn--main">
                                                    <svg class="btn__icon">
                                                        <use xlink:href="#icon__search"></use>
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </th>
                            <th>
                                <v-select
                                        v-model="filterForm.loginType"
                                        label="title"
                                        :reduce="option=>option.id"
                                        :placeholder="getTranslation('selectFromList')"
                                        :options="loginTypes"
                                />
                            </th>
                            <th colspan="2">
                                <div v-if="!eventId" class="form__tillfrom-row">
                                    <div>
                                        <date-picker @change="filterForm.page=1;fetchLogins()" v-model="filterForm.dateFrom"></date-picker>
                                    </div>

                                    <div class="form__tillfrom-sep"></div>

                                    <div>
                                        <date-picker @change="filterForm.page=1;fetchLogins()" v-model="filterForm.dateTo"></date-picker>
                                    </div>
                                </div>
                            </th>
                            <th>
                                <v-select
                                        v-model="filterForm.status"
                                        label="title"
                                        :reduce="option=>option.id"
                                        :placeholder="getTranslation('selectFromList')"
                                        :options="statuses"
                                />
                            </th>
                            <th>
                                <button @click="resetFilter" class="btn  btn--sm  btn--main">{{getTranslation('reset')}}</button>
                            </th>
                        </tr>
                        <tr class="table-3__row">
                            <th v-if="!candidateId" class="table-3__cell  table__hcell" style="width: 30%;">{{ getTranslation('candidate') }}</th>
                            <th v-if="!appId && !eventId" class="table-3__cell  table__hcell" style="width: 20%;">{{ getTranslation('application') }}</th>
                            <th class="table-3__cell  table__hcell" style="width: 15%;">{{ getTranslation('ipAddress') }}</th>
                            <th class="table-3__cell  table__hcell" style="width: 15%;">{{ getTranslation('identification') }}</th>
                            <th class="table-3__cell  table__hcell" style="width: 15%;">{{ getTranslation('loginDate') }}</th>
                            <th class="table-3__cell  table__hcell" style="width: 15%;">{{ getTranslation('logoutDate') }}</th>
                            <th class="table-3__cell  table__hcell" style="width: 20%;">{{ getTranslation('status') }}</th>
                            <th class="table-3__cell  table__hcell" style="width: 25%;"></th>
                        </tr>
                    </thead>
                    <tbody class="table-3__body">
                        <tr v-for="login in logins" v-bind:key="login.id" class="table-3__row">
                            <td v-if="!candidateId" class="table-3__cell">
                                <!-- PERSON -->
                                <div class="person">
                                    <div class="person__inner">
                                        <div class="person__img" :class="{'person__img--online':login.candidate.isOnline,'person__img--offline':!login.candidate.isOnline}">
                                            <a href="javascript:void(0)">
                                                <img :src="login.candidate.photoUrl || $config.noAvatarUrl" alt="Фото сотрудника">
                                            </a>
                                        </div>

                                        <div class="person__info">
                                            <h3 class="person__name">
                                                <router-link :to="{name:'api.candidate.get',params:{id:login.candidate.id},query:{appId:login.event.application.id,tab:'logins'}}" class="person__link">{{login.candidate.fullName}}</router-link>
                                            </h3>
                                            <div class="person__descr">{{login.candidate.pin}}</div>
                                        </div>
                                    </div>
                                </div>
                                <!-- / PERSON -->
                            </td>
                            <td v-if="!appId && !eventId" class="table-3__cell">
                                <router-link v-if="login.event" :to="{name:'api.application.get',params:{id:login.event.application.id}}">{{ login.event.application.title }}</router-link>
                            </td>
                            <td class="table-3__cell">
                                {{ login.ip }}
                            </td>
                            <td class="table-3__cell">
                                {{ getTranslation(login.loginTypeText) }}
                            </td>
                            <td class="table-3__cell">
                                {{ login.creationDate }}
                            </td>
                            <td class="table-3__cell">
                                {{ login.logoutDate }}
                            </td>
                            <td class="table-3__cell">
                                {{ getTranslation(login.statusText) }}
                            </td>
                            <td class="table-3__cell">
                                <div v-if="login.loginTypeText === 'CANDIDATE_FACE_ID'" class="login__img">
                                    <a :href="login.photoUrl">
                                        <img :src="login.photoUrl || $config.noAvatarUrl" />
                                    </a>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="page-layout__pagination" v-if="pagination.total && pagination.lastPage > 1 && paginated">
                <pagination :pagination="pagination" @change="()=>{fetchLogins();this.$scrollTo('#candidate-logins');}" v-model="filterForm.page"></pagination>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: "CandidateLogins",
        props: {
            candidateId: {
                required: false,
                default: null
            },
            appId: {
                required: false,
                default: null
            },
            eventId: {
                required: false,
                default: null
            },
            active: {
                type: Boolean,
                default: false
            },
            paginated: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                logins: [],
                filterForm: {
                    page: 1,
                    status: '',
                    loginType: '',
                    candidateQuery: '',
                    dateFrom: '',
                    dateTo: '',
                    appId: this.$route.query.appId || '',
                },
                statuses: [],
                loginTypes: [],
                pagination: {
                    total: '',
                    lastPage: '',
                    currentPage: ''
                },
                reset: false
            }
        },
        created() {
            if ( this.active && this.hasPermission('api.testing.event.profile.logins') ) {
                this.fetchLogins();
                if ( this.paginated )
                    this.fetchOptions()
            }
        },
        watch: {
            'active'( val ) {
                if ( val ) {
                    if ( this.paginated )
                        this.fetchOptions();
                    this.fetchLogins();
                }
            },
            'filterForm.status'() {
                if ( !this.reset )
                    this.fetchLogins();
            },
            'filterForm.loginType'() {
                if ( !this.reset )
                    this.fetchLogins();
            }
        },
        methods: {
            resetFilter() {
                this.reset = true;
                this.filterForm = {
                    page: 1,
                    status: '',
                    loginType: '',
                    dateFrom: '',
                    dateTo: '',
                    appId: '',
                    query: '',
                };

                this.$router.replace( { query: {} } )
                    .catch( () => {
                    } );

                this.fetchLogins().then( () => {
                    this.reset = false;
                } );
            },
            fetchOptions() {
                this.axios.get( this.$config.urls.candidate.loginOptions.url )
                    .then( response => {
                        this.statuses = this.objectToArray( response.data.data.statuses, false, true );
                        this.loginTypes = this.objectToArray( response.data.data.loginTypes, false, true );
                    } ).catch(()=>{});
            },
            fetchLogins() {

              if (! this.hasPermission('api.testing.event.profile.logins') )
                return ;

                let params = this.cleanObject( { ...this.filterForm } );

                if ( this.appId )
                    params.appId = this.appId;

                let url = this.$config.urls.candidate.logins.url.replace( ':id', this.candidateId );

                if ( this.eventId ) {
                    params.appId = null;
                    params.eventId = this.eventId;
                    url = this.$config.urls.event.logins.url.replace( ':id', this.eventId );
                }

                return this.axios.get( url, { params: params } )
                           .then( response => {

                               this.logins = response.data.data.items;

                               if ( this.paginated ) {
                                   this.pagination.currentPage = response.data.data.activePage;
                                   this.filterForm.page = response.data.data.activePage;
                                   this.pagination.total = response.data.data.totalItemsCount;
                                   this.pagination.lastPage = response.data.data.pages;
                               }
                           } ).catch(()=>{});
            },
        }
    }
</script>

<style scoped>

</style>
